import { createContext, useContext, useEffect, useState } from 'react'
import { CalendarType, Filter, Mode } from '../common/types/calendar'
import { initialCalendarState } from '../constants/context/calendar'
import useColumns from '../hooks/useColumns'

export const CalendarContext = createContext<CalendarType>({
  ...initialCalendarState,
})

export const useCalendarContext = (): CalendarType => useContext(CalendarContext)

export const useCalendar = (): CalendarType => {
  const [date, setDate] = useState(initialCalendarState.date)
  const [mode, setMode] = useState<Mode>(initialCalendarState.mode)
  const { columns, isLoading } = useColumns()
  const [filtered, setFiltered] = useState<Filter[]>(initialCalendarState.filtered)

  useEffect(() => {
    if (columns) {
      setFiltered(columns)
    }
  }, [isLoading])

  return {
    columns: columns || initialCalendarState.columns,
    date,
    filtered,
    mode,
    setDate,
    setFiltered,
    setMode,
  }
}
